/* eslint-disable max-lines-per-function */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import styles from "./styles";
import { Text } from "@react-pdf/renderer";

const WoodBatPdfPage = (woodBatData: any): any => {
  let htmlData: any = [];

  woodBatData?.forEach((product: any) => {
    const productCustomizationJson = JSON.parse(product?.ProductCustomizationJson);

    htmlData = [
      ...htmlData,
      <Text key={product?.ConfigurationName} style={styles.productText}>
        {product?.ConfigurationName} (<Text style={styles.designIdColor}>{product?.DesignId}</Text>)
      </Text>,

      <Text key={product.SKU} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          SKU:
        </Text>{" "}
        {product.SKU}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Design Id:
        </Text>{" "}
        {product.DesignId}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Design Name:
        </Text>{" "}
        {product.ProductName}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Design Type:
        </Text>{" "}
        {product.DesignType}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Order Id:
        </Text>{" "}
        {productCustomizationJson?.OrderID}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Price:
        </Text>{" "}
        {productCustomizationJson?.PriceWithCurrency}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Product:
        </Text>
      </Text>,

      <Text key={""} style={styles.level2Spacing}>
        <Text key={""} style={styles.dataKey}>
          Length:
        </Text>{" "}
        {productCustomizationJson?.product["length"]}
      </Text>,

      <Text key={""} style={styles.level2Spacing}>
        <Text key={""} style={styles.dataKey}>
          Model:
        </Text>{" "}
        {productCustomizationJson?.product["model"]}
      </Text>,

      <Text key={""} style={styles.level2Spacing}>
        <Text key={""} style={styles.dataKey}>
          Weight:
        </Text>{" "}
        {productCustomizationJson?.product["weight"]}
      </Text>,

      <Text key={""} style={styles.level2Spacing}>
        <Text key={""} style={styles.dataKey}>
          Wood species:
        </Text>{" "}
        {productCustomizationJson?.product["woodSpecies"]}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Colors:
        </Text>
      </Text>,

      <Text key={""} style={styles.level2Spacing}>
        <Text key={""} style={styles.dataKey}>
          Bat color:
        </Text>{" "}
        {productCustomizationJson?.colors["batColor"]}
      </Text>,

      <Text key={""} style={styles.level2Spacing}>
        <Text key={""} style={styles.dataKey}>
          Color combo:
        </Text>{" "}
        {productCustomizationJson?.colors["colorCombo"]}
      </Text>,

      <Text key={""} style={styles.level2Spacing}>
        <Text key={""} style={styles.dataKey}>
          Oval logo:
        </Text>{" "}
        {productCustomizationJson?.colors["ovalLogo"]}
      </Text>,

      <Text key={""} style={styles.level2Spacing}>
        <Text key={""} style={styles.dataKey}>
          Barrel:
        </Text>{" "}
      </Text>,

      <Text key={""} style={styles.level3pacing}>
        <Text key={""} style={styles.dataKey}>
          Type:
        </Text>{" "}
        {productCustomizationJson?.colors["barrel"]["type"]}
      </Text>,

      <Text key={""} style={styles.level3pacing}>
        <Text key={""} style={styles.dataKey}>
          Finish:
        </Text>{" "}
        {productCustomizationJson?.colors["barrel"]["finish"]}
      </Text>,

      <Text key={""} style={styles.level2Spacing}>
        <Text key={""} style={styles.dataKey}>
          Handle:
        </Text>{" "}
      </Text>,

      <Text key={""} style={styles.level3pacing}>
        <Text key={""} style={styles.dataKey}>
          Type:
        </Text>{" "}
        {productCustomizationJson?.colors["handle"]["type"]}
      </Text>,

      <Text key={""} style={styles.level3pacing}>
        <Text key={""} style={styles.dataKey}>
          Finish:
        </Text>{" "}
        {productCustomizationJson?.colors["handle"]["finish"]}
      </Text>,

      <Text key={""} style={styles.level2Spacing}>
        <Text key={""} style={styles.dataKey}>
          Stripe:
        </Text>{" "}
      </Text>,

      <Text key={""} style={styles.level3pacing}>
        <Text key={""} style={styles.dataKey}>
          Color:
        </Text>{" "}
        {productCustomizationJson?.colors["stripe"]["color"]}
      </Text>,

      <Text key={""} style={styles.level3pacing}>
        <Text key={""} style={styles.dataKey}>
          Size:
        </Text>{" "}
        {productCustomizationJson?.colors["stripe"]["size"]}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Filter:
        </Text>
      </Text>,

      <Text key={""} style={styles.level2Spacing}>
        <Text key={""} style={styles.dataKey}>
          Category:
        </Text>{" "}
        {productCustomizationJson?.filter["category"]}
      </Text>,

      <Text key={""} style={styles.level2Spacing}>
        <Text key={""} style={styles.dataKey}>
          Group:
        </Text>{" "}
        {productCustomizationJson?.filter["group"]}
      </Text>,

      <Text key={""} style={styles.level2Spacing}>
        <Text key={""} style={styles.dataKey}>
          Series:
        </Text>{" "}
        {productCustomizationJson?.filter["series"]}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Options:
        </Text>
      </Text>,

      <Text key={""} style={styles.level2Spacing}>
        <Text key={""} style={styles.dataKey}>
          Cupped end:
        </Text>{" "}
        {productCustomizationJson?.options["cuppedEnd"]}
      </Text>,

      <Text key={""} style={styles.level2Spacing}>
        <Text key={""} style={styles.dataKey}>
          Display tube:
        </Text>{" "}
        {productCustomizationJson?.options["displayTube"]}
      </Text>,

      <Text key={""} style={styles.level2Spacing}>
        <Text key={""} style={styles.dataKey}>
          Grip tape:
        </Text>{" "}
        {productCustomizationJson?.options["gripTape"]}
      </Text>,

      <Text key={""} style={styles.level2Spacing}>
        <Text key={""} style={styles.dataKey}>
          Knob style:
        </Text>{" "}
        {productCustomizationJson?.options["knobStyle"]}
      </Text>,
    ];
  });
  return htmlData;
};

export default WoodBatPdfPage;
